import React from "react";

const Details = ({ rowData }) => {
  const fields = [
    { label: "ID", key: "id" },
    { label: "Kiosk ID", key: "kioskId" },
    { label: "Kiosk Name", key: "kioskName" },
    { label: "User ID", key: "userId" },
    { label: "User Name", key: "userName" },
    { label: "Cash Acceptor Amount", key: "cashAcceptorAmount" },
    { label: "Cash Acceptor Collected", key: "cashAcceptorCollect" },
    { label: "Cash Acceptor Remaining", key: "cashAcceptorRemaining" },
    { label: "Cards Available", key: "cardsAvailable" },
    { label: "Cards Inserted", key: "cardsInserted" },
    { label: "Receipts Printer Status", key: "receiptsPrinterStatus" },
    {
      label: "Receipts Roll Inserted",
      key: "receiptsRollInserted",
      boolean: true,
    },
    { label: "Transaction Type", key: "transactionType" },
    { label: "Created By", key: "createdBy" },
    { label: "Created Date", key: "createdDate" },
    { label: "Last Updated", key: "lastUpdated" },
    { label: "Modified By", key: "modifiedBy" },
    { label: "Modified Date", key: "modifiedDate" },
  ];

  return (
    <div className="main-form form-details">
      <div className="p-fluid formgrid grid">
        {fields.map(({ label, key, boolean }) => (
          <div className="field col-12 md:col-4 mb-3" key={key}>
            <label>{label}</label>
            <p>
              {boolean
                ? rowData?.[key]
                  ? "Yes"
                  : "No"
                : rowData?.[key] ?? "N/A"}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Details;
